exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-cell-group{background-color:#fff}.van-cell-group__title{padding:16px 16px 8px;color:#969799;font-size:14px;line-height:16px}", "", {"version":3,"sources":["/Users/hangz/Work/projects/vision-h5/node_modules/vant/es/cell-group/index.css"],"names":[],"mappings":"AAAA,gBAAgB,qBAAqB,CAAC,uBAAuB,sBAAsB,cAAc,eAAe,gBAAgB,CAAC","file":"index.css","sourcesContent":[".van-cell-group{background-color:#fff}.van-cell-group__title{padding:16px 16px 8px;color:#969799;font-size:14px;line-height:16px}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/cell-group/index.css
// module id = MYI5
// module chunks = 215